import { IGraphConfig } from '../../interfaces/graph.interface';
import { MedicalMisurationType } from './misuration.component';

export const GraphMisurationData: Array<IGraphConfig & { id: MedicalMisurationType }> = [
  {
    id: 'bpm',
    design: {
      type: 'scatter',
      beginAtZero: true,
      color: '#FFB2C2B3',
      borderColor: '#f96683',
      pointSize: 5,
    },
  },
  {
    id: 'weight',
    design: {
      type: 'line',
      beginAtZero: false,
      color: '#FFB2C2B3',
      borderColor: '#f96683',
      pointSize: 7,
    },
  },
  {
    id: 'temperature',
    design: {
      type: 'bar',
      beginAtZero: true,
      minValueY: 35,
      color: '#36A2EB',
      borderColor: '#36A2EB',
    },
  },
  {
    id: 'pressure',
    design: {
      type: 'bar',
      beginAtZero: false,
      color: '#FFB2C2B3',
      borderColor: '#f96683',
      borderWidth: 2,
      borderRadius: 30,
      minValueY: 0,
      maxValueY: 280,
      borderSkipped: false,
    },
  },
  {
    id: 'waistCircumference',
    design: {
      type: 'line',
      beginAtZero: false,
      color: '#4CBFC0',
      borderColor: '#4CBFC0',
      borderDash: 4,
      pointSize: 3,
    },
  },
  {
    id: 'hipCircumference',
    design: {
      type: 'line',
      beginAtZero: false,
      color: '#4CBFC0',
      borderColor: '#4CBFC0',
      borderDash: 4,
      pointSize: 3,
    },
  },
  {
    id: 'wristCircumference',
    design: {
      type: 'line',
      beginAtZero: false,
      color: '#4CBFC0',
      borderColor: '#4CBFC0',
      borderDash: 4,
      pointSize: 3,
    },
  },
  {
    id: 'glycemia',
    design: {
      type: 'line',
      beginAtZero: false,
      graphicFill: true,
      color: '#36A2EBA4',
      borderColor: '#36A2EB',
      pointSize: 7,
      pointBackgroundColor: '#FFFFFF',
      minValueY: 0,
      maxValueY: 170,
    },
  },
];
